import m from '../../vendor/mithril.js';
import {Control} from './base.js'

const divide = (components, edgeClasses, middleClasses) => {
    if (components.length === 1) {
        return m(middleClasses, components[0])
    } else if (components.length === 2) {
        return [
            m(edgeClasses, components[0]),
            m(middleClasses, components[1]),
        ]
    } else if (components.length > 2) {
        return [
            m(edgeClasses, components[0]),
            m(middleClasses, components.slice(1, components.length - 1)),
            m(edgeClasses, components[components.length - 1])
        ]
    } else {
        return null
    }
}

const separatedChildren = (vnode) => {
    const separator = vnode && vnode.attrs && vnode.attrs.separator
    let children = vnode.children
    if (children && children.length > 1 && separator) {
        children = []
        for (const [i, child] of vnode.children.entries()) {
            children.push(child)
            if (i < vnode.children.length - 1) children.push(separator())
        }
    }
    return children
}

const randomColor = () => {
    const letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
    }
    return color
}

const getConfigClasses = (vnode) =>
    (vnode.attrs.justify ? '.justify-' + vnode.attrs.justify : '') +
    (vnode.attrs.align ? '.items-' + vnode.attrs.align : '') +
    (vnode.attrs.grow ? '.flex-grow' : '') +
    (vnode.attrs.marginBottom ? '.mb-' + vnode.attrs.marginBottom : '')

export const Layout = {
    TestDiv: {
        view: (vnode) => m('div', { style: { backgroundColor: randomColor() } }, 'Test')
    },
    HBox: {
        view: (vnode) => m('.flex.flex-row' + getConfigClasses(vnode), {class: vnode.attrs.class}, separatedChildren(vnode))
    },
    VBox: {
        view: (vnode) => m('.flex.flex-col' + getConfigClasses(vnode), {class: vnode.attrs.class}, separatedChildren(vnode))
    },
    PaddedHBox: {
        view: (vnode) => m('.flex.flex-row.space-x-2' + getConfigClasses(vnode), {class: vnode.attrs.class}, separatedChildren(vnode))
    },
    PaddedHBox2: {
        view: (vnode) => m('.flex.flex-col.sm:flex-row.sm:space-x-2' + getConfigClasses(vnode), {class: vnode.attrs.class}, separatedChildren(vnode))
    },
    PaddedVBox: {
        view: (vnode) => m('.flex.flex-col.space-y-2' + getConfigClasses(vnode), {class: vnode.attrs.class}, separatedChildren(vnode))
    },
    HTriple: {
        view: (vnode) => m(
            '.flex.flex-row.flex-grow.h-full',
            divide(vnode.children, '.flex.flex-row.flex-grow-0', '.flex-grow.justify-center')
        )
    },
    VTriple: {
        view: (vnode) => m(
            '.flex.flex-col.flex-grow.v-full',
            divide(vnode.children, '.flex.flex-col.flex-grow-0', '.flex-grow.justify-center')
        )
    },
    PaddedHTriple: {
        view: (vnode) => m(
            '.flex.flex-row.flex-grow.h-full.space-x-2',
            divide(vnode.children, '.flex.flex-row.flex-grow-0', '.flex-grow.justify-center')
        )
    },
    PaddedVTriple: {
        view: (vnode) => m(
            '.flex.flex-col.flex-grow.v-full.space-y-2',
            divide(vnode.children, '.flex.flex-col.flex-grow-0', '.flex-grow.justify-center')
        )
    },
}
